module.exports = __webpack_public_path__ + "img/4-1_03.401c7b00.jpg";